import { format } from 'date-fns'

const FormatDate = (date) => {
    return format(date, 'dd/MM/yyyy')
}
export default FormatDate;